import React from 'react';
import styles from './Header.module.css';
import User from '../User/User';
import { useTranslation } from 'react-i18next';

const Header = () => {
  const { t, i18n } = useTranslation();
  const changeLanguage = (lng: string) => {
    i18n.changeLanguage(lng);
  };

  return (
    <header id="header" className={styles.global} role="banner">
      <div id="header-top" className={styles.top}>
        {false && <div className={styles.userMenu}><User /></div>}
        <a href="https://www.quaibranly.fr/" className={`${styles.logo} ${styles.ir}`}>Quai Branly - Jacques Chirac museum</a>
        <a href="https://www.quaibranly.fr/fr/si-vous-etes/en-situation-de-handicap" target="_blank" className={`${styles.access} ${styles.ir}`}>Visitors with disabilities</a>
        <ul>
          <li className={styles.linktree}>
            <a href="https://linktr.ee/mediathequequaibranly" target="_blank" className={styles.ir}>Linktree
              <svg className={styles.svgAnim} version="1.1" xmlns="http://www.w3.org/2000/svg">
                <path d=" M 25, 25 m -24, 0 a 24,24 0 1,0 48,0 a 24,24 0 1,0 -48,0" fill="none" stroke="#39b54b" strokeWidth="2"></path>
              </svg>
            </a>
          </li>
          <li className={styles.facebook}>
            <a href="https://www.facebook.com/museeduquaibranlyjacqueschirac" target="_blank" className={styles.ir}>Facebook
              <svg className={styles.svgAnim} version="1.1" xmlns="http://www.w3.org/2000/svg">
                <path d=" M 25, 25 m -24, 0 a 24,24 0 1,0 48,0 a 24,24 0 1,0 -48,0" fill="none" stroke="#39b54b" strokeWidth="2"></path>
              </svg>
            </a>
          </li>
          <li className={styles.twitter}>
            <a href="http://twitter.com/quaibranly" target="_blank" className={styles.ir}>Twitter
              <svg className={styles.svgAnim} version="1.1" xmlns="http://www.w3.org/2000/svg">
                <path d=" M 25, 25 m -24, 0 a 24,24 0 1,0 48,0 a 24,24 0 1,0 -48,0" fill="none" stroke="#39b54b" strokeWidth="2"></path>
              </svg>
            </a>
          </li>
          <li className={styles.instagram}>
            <a href="https://instagram.com/quaibranly" target="_blank" title="Instagram" className={styles.ir}>Instagram
              <svg className={styles.svgAnim} version="1.1" xmlns="http://www.w3.org/2000/svg">
                <path d=" M 25, 25 m -24, 0 a 24,24 0 1,0 48,0 a 24,24 0 1,0 -48,0" fill="none" stroke="#39b54b" strokeWidth="2"></path>
              </svg>
            </a>
          </li>
        </ul>
        <div className={styles.languageSelectorContainer}>
          <select
            className={styles.languageSelector}
            value={i18n.language}
            onChange={(event) => changeLanguage(event.target.value)}
          >
            <option value="en">English</option>
            <option value="fr">Français</option>
          </select>
        </div>
      </div>

      <div className={styles.bottom}>
        <nav id="header-navigation" role="navigation">
          <a href="https://www.quaibranly.fr/" className={`${styles.logo} ${styles.ir}`}>Quai Branly - Jacques Chirac museum</a>
          <ul>
            <li><a href="https://www.quaibranly.fr/fr/collections/toutes-les-collections/explorer-les-collections-1#c217655" target="_blank" rel="noopener noreferrer" data-smenu="1">{t("header_collections")}</a></li>
            <li><a href="https://www.quaibranly.fr/fr/collections/toutes-les-collections/explorer-les-collections-1#c217656" target="_blank" rel="noopener noreferrer" data-smenu="2">{t("header_cultural_warnings")}</a></li>
            <li><a href="https://www.quaibranly.fr/fr/collections/toutes-les-collections/explorer-les-collections-1#c217657" target="_blank" rel="noopener noreferrer" data-smenu="3">{t("header_reusing_contents")}</a></li>
          </ul>
        </nav>
      </div>
    </header>
  );
};

export default Header;
